import { Component, inject, signal } from '@angular/core';
import { ToastService } from '@app/core/services/toast.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UsersService } from 'api-v3/services';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    imports: [
        MatButton,
        MatIcon,
        MatProgressSpinner,
        TranslateModule,
    ],
})
export class ChangePasswordComponent {
    private toast = inject(ToastService);
    private translate = inject(TranslateService);
    private usersService = inject(UsersService);

    isLoading = signal(false);
    hasExternalIdp: boolean;
    // Fernzugriffs-Sitzungen sind nur lesend: Ohne `user_modify` weist das
    // Backend die Passwortänderung ab — der Knopf bleibt dann gesperrt.
    canModifyProfile: boolean;

    constructor() {
        // check if the user has an external IdP (false if there is no organization or session)
        const session = inject(SessionService).getSession();
        const org = session?.organizations[0];
        this.hasExternalIdp = (org?.externalIdps?.length ?? 0) > 0;
        this.canModifyProfile = session?.permissions?.user_modify !== false;
    }

    async requestPasswordChange() {
        try {
            this.isLoading.set(true);
            await lastValueFrom(this.usersService.requestPasswordChangeV3());
            this.isLoading.set(false);
            this.toast.success(
                this.translate.instant('SETTINGS.PASSWORD.SUCCESS')
            );
        } catch (error) {
            this.isLoading.set(false);
            this.toast.error(this.translate.instant('SETTINGS.PASSWORD.ERROR'));
        }
    }
}
